import { getArticleTagsRequestParams } from 'sly/resourceCenter/helpers';
import SearchResultPage from 'sly/resourceCenter/pages/SearchResultPage';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default SearchResultPage;

export async function getServerSideProps({ query, params }) {
  const { api, store } = createApiClient(apiEndpoints);

  const { tag } = params;

  const requestParams = getArticleTagsRequestParams(query, tag);

  try {
    await Promise.all(
      [
        api.getResourceCenterCommonInfo.asAction(),
        api.getArticle.asAction(requestParams),
        api.getTopicHeader.asAction(),
      ].map(store.dispatch)
    );
  } catch (e) {
    console.error(e);
    return {
      redirect: {
        destination: '/resource-center',
        permanent: false,
      },
    };
  }

  return {
    props: {
      initialApiState: store.getState(),
      query,
      requestParams,
      tag,
    },
  };
}
